module.exports = __webpack_public_path__ + "img/documents--icon.78a1bd09.svg";